/**
 * Patient Documents feature auto-registration and exports
 *
 * This module automatically registers the patient documents feature when imported,
 * making it work seamlessly with both static and dynamic imports.
 */

import { autoRegisterFeature } from '@store/features/factory';

import { patientDocumentsFeature } from './store/feature';

// Auto-register the feature when this module is imported
autoRegisterFeature(patientDocumentsFeature);

// Export store (all store-related exports)
export * from './store';

// Export types
export * from './types';